export const fmtMoney = (n, currency = 'GHS') => {
  const v = Number(n || 0);
  return `${currency} ${v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const fmtNumber = (n) => Number(n || 0).toLocaleString();

export const fmtDate = (s) => {
  if (!s) return '—';
  try {
    return new Date(s).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  } catch (_) { return s; }
};

export const titleCase = (s) => String(s || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
